<template>
  <div class="header">
    <span class="back"></span>
    <span class="title">{{title}}</span>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data: function () {
    return {
    }
  },
  computed: {
    title () {
      if (this.$route.meta && this.$route.meta.title) {
        return this.$route.meta.title
      }
    }
  },
  created: function () {
  }
}
</script>
<style>
  .header{height: 40px; text-align: center; position: absolute; left:0; top:0; width: 100%; z-index: 10;}
  .header .title{line-height: 40px; font-size: 18px; letter-spacing: 0; text-align: center; letter-spacing: 2px;}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue